import { Injectable } from "@angular/core";
import { each, camelCase } from "lodash";

@Injectable()
export class FileService {
  constructor() {}

  createAndDownloadFile(filename, mimeType, content) {
    if (!filename || !mimeType || !content) {
      throw new Error("Filename, mime-type and content is required");
    }

    let data = `data:${mimeType};charset=UTF-8,${encodeURIComponent(content)}`;

    let downloadLink = document.createElement("a");
    downloadLink.setAttribute("href", data);
    downloadLink.setAttribute("download", filename);
    downloadLink.click();
  }
}



// WEBPACK FOOTER //
// ./src/providers/file.ts